import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function FileOutline(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
    >
      <g clipPath='url(#clip0_209_124)'>
        <path
          d='M19.74 8.33006L14.3 2.33006C14.2065 2.22647 14.0924 2.14359 13.9649 2.08675C13.8375 2.02992 13.6995 2.00039 13.56 2.00006H6.56C6.22775 1.99609 5.89797 2.05762 5.5895 2.18111C5.28103 2.30461 4.9999 2.48766 4.76218 2.71981C4.52446 2.95196 4.33479 3.22867 4.20402 3.53412C4.07324 3.83958 4.00392 4.16781 4 4.50006V19.5001C4.00392 19.8323 4.07324 20.1605 4.20402 20.466C4.33479 20.7714 4.52446 21.0482 4.76218 21.2803C4.9999 21.5125 5.28103 21.6955 5.5895 21.819C5.89797 21.9425 6.22775 22.004 6.56 22.0001H17.44C17.7723 22.004 18.102 21.9425 18.4105 21.819C18.719 21.6955 19.0001 21.5125 19.2378 21.2803C19.4755 21.0482 19.6652 20.7714 19.796 20.466C19.9268 20.1605 19.9961 19.8323 20 19.5001V9.00006C19.9994 8.75222 19.9067 8.51346 19.74 8.33006ZM17.65 9.00006H13.71C13.5038 8.97976 13.3139 8.87929 13.1811 8.72031C13.0483 8.56132 12.9833 8.35653 13 8.15006V4.00006H13.11L17.65 9.00006ZM17.44 20.0001H6.56C6.49037 20.0041 6.42063 19.9944 6.35477 19.9714C6.28892 19.9485 6.22824 19.9128 6.17621 19.8663C6.12419 19.8199 6.08184 19.7636 6.0516 19.7007C6.02137 19.6379 6.00383 19.5697 6 19.5001V4.50006C6.00383 4.43042 6.02137 4.36222 6.0516 4.29937C6.08184 4.23653 6.12419 4.18027 6.17621 4.13382C6.22824 4.08737 6.28892 4.05164 6.35477 4.02869C6.42063 4.00573 6.49037 3.996 6.56 4.00006H11V8.15006C10.9839 8.88668 11.2598 9.59978 11.7675 10.1337C12.2752 10.6677 12.9735 10.9791 13.71 11.0001H18V19.5001C17.9962 19.5697 17.9786 19.6379 17.9484 19.7007C17.9182 19.7636 17.8758 19.8199 17.8238 19.8663C17.7718 19.9128 17.7111 19.9485 17.6452 19.9714C17.5794 19.9944 17.5096 20.0041 17.44 20.0001Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_209_124'>
          <rect
            width='24'
            height='24'
            fill='transparent'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
